/**
 * Проверка «количество кратно шагу лота».
 *
 * Правило писалось под облигации: у них лот 1000 или 250 штук, и заявка на
 * 1500 невозможна. Шаг приходит с бэкенда в `assetInfo.step`, а для всего
 * остального бэкенд оставляет там null (market.service.ts, getAssetInfo).
 * На фронте null превращался в 1 — и проверка «кратно 1» запрещала любое
 * дробное количество, хотя к облигациям оно отношения не имеет.
 *
 * Дробные бумаги бэкенд помечает ненулевым `decimal_places`: для акций США
 * дороже 5 и дешевле 6000 долларов это 2 знака. Шага лота у них нет вообще,
 * поэтому кратность к ним неприменима — 7.7 NVDA это нормальная заявка, GTN
 * такие исполняет полностью (сделки #131679, #131685, #131713 и другие).
 * Для всех прочих бумаг отсутствие шага по-прежнему означает «целые штуки».
 *
 * Экран продажи получил это исключение 08.06.2026 (e5824b48), экран покупки
 * остался со старым кодом, и дробную покупку приложение не пропускало ни
 * разу. Поэтому правило живёт здесь одной функцией, а не копией на экран.
 */
export interface QuantityStepInput {
  /** Введённое пользователем количество. */
  quantity: number;
  /** `assetInfo.step` как есть: число для облигаций, null/undefined иначе. */
  step: number | null | undefined;
  /** Бумага торгуется дробно (`assetInfo.decimal_places` непустой). */
  isFractional: boolean;
}

export function isQuantityOffStep({
  quantity,
  step,
  isFractional,
}: QuantityStepInput): boolean {
  if (quantity < 0) return true;
  // Пустой ввод — не ошибка: подсказку показывать не за что.
  if (!quantity) return false;

  // Шаг прислали явно — он главнее любых признаков дробности.
  // Не прислали: у дробной бумаги кратности нет, у остальных это целые штуки.
  const effectiveStep = step || (isFractional ? null : 1);
  if (!effectiveStep) return false;

  return quantity % effectiveStep !== 0;
}
